export default "__VITE_ASSET__BGMeJkel__"